<template>
<div class="mt-4 ml-3">{{ title }}</div>
<div class="control_wrapper" v-bind:id="drop_el_id">
	<ejs-uploader ref="uploadObj" :name="type" :asyncSettings= "uploadUrls" :uploading= "onFileUpload" :success="onUploadReady" :failure="onUploadReady"
	:dropArea="drop_element" :removing= "onFileRemove" :autoUpload='true' :multiple = 'multiple' :selected="onFileSelect" :allowedExtensions="extensions" :buttons="buttons" >
	</ejs-uploader>
</div>
</template>
<script>
import { UploaderComponent } from '@syncfusion/ej2-vue-inputs';
import useUtils from '../hooks/useUtils';

export default {
	name: "Uploader",
	props: ['cId', 'title', 'type', 'multiple', 'clearInterval', 'uploadUrl', 'removeUrl', 'allowedExt', 'addToken', 'allowedTypes'],
	components: {
		'ejs-uploader' : UploaderComponent,
	},
	emits: ['onOperationReady'],
	setup() {
		const { sleep } = useUtils();
		return {
			sleep,
		}
	},
	data() {
		return {
			uploadUrls:  {
				saveUrl: this.uploadUrl ? this.uploadUrl : '/customer/upload/save',
				removeUrl: this.removeUrl ? this.removeUrl : '/customer/upload/remove'
			},
			drop_el_id: "drop_element_"+this.type,
			drop_element: "#drop_element_"+this.type,
			allowedFileTypes: this.allowedTypes ? this.allowedTypes : ['png', 'jpg', 'jpeg', 'gif', 'tiff', 'pdf', 'zip'],
			extensions: this.allowedExt ? this.allowedExt : "image/*, application/pdf",
			max_file_size: 15728640, //15 MB
			buttons: { browse : this.$t('eny.file_browse')},
		};
	},
	mounted() {
		const dropText=document.getElementsByClassName('e-file-drop');
		for (let i = 0; i < dropText.length; i++) {
			dropText[i].innerHTML= this.$t('eny.file_drop_zone');
		}
	},
	methods: {
		onProgress(args) {
		},
		onFileRemove(args) {
			this.onFileUpload(args);
			args.postRawFile = false;
		},
		onFileSelect(args) {
			if (args.event.type === 'drop' || args.event.type === 'change') {
				let files = args.filesData;
				if (this.allowedFileTypes.indexOf(files[0].type.toLowerCase()) === -1) {
					files[0].status = this.$t('eny.file_type_not_allowed', {exts: this.allowedFileTypes.toString()});
					files[0].statusCode = '0';
				} else if (files[0].size>this.max_file_size) {
					files[0].status = this.$t('eny.file_too_big', {max_size: this.max_file_size/1024/1024});
					files[0].statusCode = '0';
				}
				args.isModified = true;
			}
		},
		onFileUpload(args) {
			if (args.currentRequest) {
				const xsrfEl=document.getElementsByName('csrf-token')[0];
				args.currentRequest.setRequestHeader("X-CSRF-TOKEN", xsrfEl.content);
				if (this.addToken) {
					args.currentRequest.setRequestHeader("Authorization", `Bearer ${this.$keycloak.token}`);
				}
			}
			// add addition data as key-value pair.
			if (this.cId) {
				args.customFormData = [{'cid': this.cId}];
			}
		},
		onUploadReady(args) {
			if (args.response.statusText!='') {
				if (args.operation==='upload' || args.operation==='remove') {
						args.file.status=args.response.statusText;
						args.file.statusCode=args.response.statusCode;
						args.statusText=args.response.statusText;
						args.isModified = true;
				}
			}
			if (args.name=="success") {
				if (this.clearInterval) {
					//clear the list of downloaded files
					const uploadObj=this.$refs.uploadObj;
					this.sleep(this.clearInterval*1000).then(function() {
						uploadObj.clearAll();
					});
				}
				this.$emit("onOperationReady");
			}
		},
	},
}
</script>
<style>
#app .control-section {
	height: 100%;
	min-height: 200px;
}
.upload-title {
	@apply mt-4 ml-3;
}
#app .default-sample .control_wrapper {
	max-width: 450px;
	min-width: 245px;
	margin: auto;
}
.e-upload .e-upload-files {
	@apply bg-white;
}
</style>